import React, { useState } from "react";
import { Button, Card, Flex, Modal, Table, Typography } from "antd";
import wordData from "../data/wordData.json";
import useStore from "../store/useStore";
import { useNavigate } from "react-router-dom";
import { FilterTwoTone } from "@ant-design/icons";
import WordFilterModal from "./WordFilterModal";
import { v4 as uuidv4 } from "uuid";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

const { Title, Text } = Typography;

const mockData = (grade, publisher) => {
  if (!grade || !publisher) return [];

  const filteredData = wordData.filter((item) => {
    const gradeMatch = Array.isArray(grade)
      ? grade.includes(item.grade)
      : item.grade === grade;

    return gradeMatch && item.publisher === publisher;
  });

  const groupedData = filteredData.reduce((acc, item) => {
    const key = item.lesson;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const result = Object.entries(groupedData).map(([lesson, words]) => ({
    key: lesson,
    title: `${lesson}단원 - ${words[0].topic}`,
    words: words.map((word) => ({
      key: word.id,
      content: word.content,
    })),
  }));
  return result;
};

const TransferComponent = ({ grade, publisher, refs }) => {
  const [modalopen, setModalOpen] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const { ref4, ref5, ref6, ref7 } = refs;
  const userId = localStorage.getItem("userId");

  const {
    selectedUnits,
    setSelectedUnits,
    selectedWords,
    setSelectedWords,
    setStep,
  } = useStore();
  const navigate = useNavigate();

  const units = mockData(grade, publisher);

  const filteredWords = units
    .filter((unit) => selectedUnits.includes(unit.key))
    .flatMap((unit) => unit.words);

  const createCardGame = async (content) => {
    try {
      const newGame = {
        id: uuidv4(),
        selectedWordIds: content.selectedWordIds,
      };

      console.log('selectedWordIds', content.selectedWordIds)
      // 랜덤으로 넣었는데 데이터는 왜 순서대로 나오냐구..

      const gamesCollection = collection(db, "users", userId, "cardGames");
      const docRef = await addDoc(gamesCollection, newGame);

      return docRef.id;
    } catch (error) {
      console.error("Error creating card game: ", error);
    }
  };

  const handleWordSelect = async () => {
    console.log('selectedWords', selectedWords);
    const selectedWordIds = selectedWords;

    const shuffledWordIds = selectedWordIds.sort(() => Math.random() - 0.5);

    const gameId = await createCardGame({
      selectedWordIds: shuffledWordIds,
    });

    navigate(`/card-game/${gameId}`);
  };

  const showModal = () => {
    setModalOpen(true);
  };

  const handleOk = () => {
    setModalOpen(false);
    handleWordSelect();
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleUnitChange = (selectedRowKeys) => {
    setSelectedUnits(selectedRowKeys);

    // 단원이 모두 선택 해제되면 step 2
    if (selectedRowKeys.length === 0) {
      setStep(2);
      setSelectedWords([]);
      return;
    }

    // 단원이 선택된 경우
    setStep(3);
    const newFilteredWords = units
      .filter((unit) => selectedRowKeys.includes(unit.key))
      .flatMap((unit) => unit.words);

    setSelectedWords(
      selectedWords.filter((wordKey) =>
        newFilteredWords.some((word) => word.key === wordKey)
      )
    );
  };

  const wordfilterModalOpen = () => {
    setFilterModalOpen(true);
  };

  return (
    <Flex className="w-full flex gap-4 items-start justify-center flex-col md:flex-row">
      <Card
        ref={ref4}
        className={`w-full max-w-[100%] md:max-w-[530px] rounded-[20px] ${
          !grade || !publisher ? "bg-[#ececec]" : "bg-white"
        }`}
      >
        <Title level={4} style={{ display: "inline", marginRight: "14px" }}>
          단원
        </Title>
        {!grade || !publisher ? (
          <Text type="secondary">학년과 교과서를 먼저 선택 해주세요.</Text>
        ) : (
          <>
            <Text type="secondary" className="hide-mobile">
              열려 있는 단원의 토픽에서만 단어장을 할 수 있습니다.
            </Text>
            <Table
              className="custom-unit-table scrollTableStyles mt-4"
              rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys) => {
                  setSelectedUnits(selectedRowKeys);
                  handleUnitChange(selectedRowKeys);
                },
                selectedRowKeys: selectedUnits,
              }}
              columns={[
                {
                  dataIndex: "title",
                  title: "전체선택/해제",
                },
              ]}
              dataSource={units}
              size="small"
              pagination={false}
              scroll={{ y: 600 }}
              style={{ maxHeight: 650 }}
            />
          </>
        )}
      </Card>

      <Card
        ref={ref5}
        title={`선택된 단어 (${selectedWords.length})`}
        styles={{
          header: {
            fontSize: "18px",
            fontWeight: "700",
            display: selectedUnits.length === 0 ? "none" : "flex",
            background: "#CAE3FF",
            borderRadius: "20px 20px 0 0",
            color: "#3D90EF",
          },
        }}
        className={`reletive w-full max-w-[100%] md:max-w-[50%] 2xl:max-w-[500px] rounded-[20px] ${
          selectedUnits.length === 0 ? "bg-[#ececec]" : "bg-[#F1F8FF]"
        }`}
      >
        <>
          <div
            className="absolute top-3 right-0 md:right-5 flex justify-end gap-3 mr-8 items-center"
            style={{
              fontSize: "20px",
              display: selectedUnits.length === 0 ? "none" : "flex",
            }}
          >
            <button ref={ref6}>
              <FilterTwoTone onClick={wordfilterModalOpen} />
            </button>
          </div>
          {filteredWords.length > 0 ? (
            <>
              <Table
                className="custom-word-table scrollTableStyles"
                rowSelection={{
                  type: "checkbox",
                  onChange: (selectedRowKeys) => {
                    setSelectedWords(selectedRowKeys);
                  },
                  selectedRowKeys: selectedWords,
                }}
                columns={[
                  {
                    title: "전체선택/해제",
                    dataIndex: "content",
                    key: "content",
                  },
                ]}
                dataSource={filteredWords}
                size="small"
                pagination={false}
                scroll={{ y: 600 }}
                style={{ maxHeight: 650 }}
              />
              <Button
                ref={ref7}
                type="primary"
                onClick={() => showModal()}
                disabled={selectedWords.length <= 2}
                block
                className="py-6 text-base mt-5 border-none rounded-xl bg-[#258BFF]"
              >
                저장하기
              </Button>
            </>
          ) : (
            <Text
              type="secondary"
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              단원을 선택해주세요.
            </Text>
          )}

          <Modal
            title="알림"
            open={modalopen}
            onOk={handleOk}
            onCancel={handleCancel}
            closeIcon={false}
            okText="확인"
            cancelText="취소"
            className="text-center"
          >
            <p className="text-center py-5 px-5">
              <span className="block font-bold text-[#3D90EF]">
                [ 선택된 단어 : {selectedWords.length}개 ]
              </span>
              이대로 단어장을 만드시겠습니까?
            </p>
          </Modal>
        </>
      </Card>

      <Modal
        title="단어 필터"
        className="word-filter-modal"
        open={filterModalOpen}
        closeIcon={false}
        width={450}
        footer={null}
      >
        <WordFilterModal setFilterModalOpen={setFilterModalOpen} />
      </Modal>
    </Flex>
  );
};

export default TransferComponent;